import { NavLink } from 'react-router'
import { HBase, type HBaseProps, type HProps } from '#ui/H.tsx'
import type { LinkProps } from '#ui/Link.tsx'
import { getHatchedClassFn, type TextClasses } from '#utils/ds.ts'

type HAProps = HProps & Omit<LinkProps, 'className'>

const hatchedClassFn = getHatchedClassFn<TextClasses>()

function HABase({
  as,
  children,
  className,
  icon,
  level,
  ...props
}: HBaseProps & Omit<LinkProps, 'className'>) {
  const classes = className ? className(hatchedClassFn) : ''

  return (
    <HBase as={as} className={x => x('_', classes)} icon={icon} level={level}>
      <NavLink {...props} className='truncate hover:opacity-70'>
        {children}
      </NavLink>
    </HBase>
  )
}

export const H1A = (props: HAProps) => <HABase {...props} level={1} />
export const H2A = (props: HAProps) => <HABase {...props} level={2} />
export const H3A = (props: HAProps) => <HABase {...props} level={3} />
export const H4A = (props: HAProps) => <HABase {...props} level={4} />
export const H5A = (props: HAProps) => <HABase {...props} level={5} />
export const H6A = (props: HAProps) => <HABase {...props} level={6} />
